import { Button } from '@/components/ui/button';
import { PATH_DOCS } from '@/constants';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import PATH_PAGE from '@/router/path';
import { ArrowTopRightIcon, PlusIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import InstanceTable from './InstanceTable';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import TerminatedInstanceTable from './TerminatedInstanceTable';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { navOneClickDeploy } from '@/components/layout/navigation/configNav';
import { cn } from '@/lib/utils';
import { StatusGetInstances } from '@/service/one-click-deploy/type';
import { useGetDedicateInstances } from '@/service/one-click-deploy/hook';
import { columnsDedicateInstance } from './InstanceTable/type';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';

const OneClickDeployView = () => {
  const { workspaceId } = useParamWorkspaceId();
  const isAddInstance = true;

  const instances = useGetDedicateInstances({
    workspace_id: workspaceId,
  });

  const dataActive: columnsDedicateInstance[] =
    instances.data?.instances_info
      ?.filter((instance) => instance.status !== StatusGetInstances.Terminated)
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      )
      .map((instance) => ({
        id: instance.instance_id,
        createAt: instance.created_at,
        instanceName: instance.instance_name,
        modelName: instance.model_repo,
        status: instance.status,
      })) || [];

  const dataTerminated: columnsDedicateInstance[] =
    instances.data?.instances_info
      ?.filter((instance) => instance.status === StatusGetInstances.Terminated)
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      )
      .map((instance) => ({
        id: instance.instance_id,
        createAt: instance.created_at,
        instanceName: instance.instance_name,
        modelName: instance.model_repo,
        status: instance.status,
        updatedAt: instance?.updated_at,
      })) || [];

  const navbarConfig = useMemo(
    () => ({
      title: 'One click Deploy',
      navbar: navOneClickDeploy(workspaceId),
    }),
    [workspaceId]
  );
  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return (
    <div className="container mt-8">
      <div className="mt-4 flex items-center justify-between">
        <div className="text-base font-semibold">Instance</div>
        <div className="mt-4 flex items-center">
          <Link to={PATH_PAGE.setting.serviceQuota} className="underline">
            <Button variant={'link'} size={'sm'}>
              Quota
            </Button>
          </Link>
          <Link
            to={PATH_DOCS.root}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant={'link'} size={'sm'}>
              Docs
              <ArrowTopRightIcon />
            </Button>
          </Link>
          <Link
            to={PATH_PAGE.dashboard.oneClickDeploy.create(workspaceId)}
            className={cn(!isAddInstance && 'pointer-events-none')}
          >
            <Button
              variant={isAddInstance ? 'primary' : 'secondary'}
              startIcon={<PlusIcon />}
              disabled={!isAddInstance}
            >
              Add new Instance
            </Button>
          </Link>
        </div>
      </div>
      <div className="mt-4">
        <Tabs defaultValue="active">
          <TabsList>
            <TabsTrigger value="active">Active</TabsTrigger>
            <TabsTrigger value="terminated">Terminated</TabsTrigger>
          </TabsList>

          <>
            <TabsContent value="active">
              <InstanceTable
                data={dataActive}
                isLoading={instances.isLoading}
              />
            </TabsContent>
            <TabsContent value="terminated">
              <TerminatedInstanceTable data={dataTerminated} />
            </TabsContent>
          </>
        </Tabs>
      </div>
    </div>
  );
};

export default OneClickDeployView;
